import { useMemo } from "react";
import ProviderHubService from "@app/projects/network-assessment/provider-hub/providerHubService";
import { DropdownItem } from "@app/shared/checkbox-dropdown/types";
import { useQuery } from "@tanstack/react-query";

export interface TopPrescriptionsResult {
  data: DropdownItem<string>[];
  hasData: boolean;
  isError: boolean;
  isLoading: boolean;
}

export const TOP_PRESCRIPTIONS_QUERY_PREFIX = "provider-hub__top-prescriptions";

export const useTopPrescriptions = (projectId: number | undefined, projectRunConfigurationId: number | undefined, enabled: boolean): TopPrescriptionsResult => {
  const providerHubService = useMemo(() => new ProviderHubService(), []);

  const queryResult = useQuery<string[]>({
    enabled: enabled && !!projectId && !!projectRunConfigurationId,
    queryFn: async ({ signal }) => providerHubService.getTopPrescriptions(projectId, projectRunConfigurationId, signal),
    queryKey: [TOP_PRESCRIPTIONS_QUERY_PREFIX, projectId, projectRunConfigurationId],
    staleTime: 5 * 60 * 1000,
  });

  return {
    data: queryResult.data?.map(p => ({ key: p, name: p })) ?? [],
    hasData: queryResult.isSuccess && queryResult.data?.length > 0,
    isError: queryResult.isError,
    isLoading: queryResult.isPending,
  };
}
